import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import logo from "../../images/dut.png";
import nov from "../../images/nov.png";
import arch from "../../images/arch.png";
import tick from "../../images/tick.png";
import aud from "../../images/aud.png";
import { Link } from "react-router-dom";
import "./home.css";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import soonImg from "../../images/soon.png";
import Button from "../../components/CustomButtons/Button";
import Grid from '@material-ui/core/Grid';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalSoon1: false,
      modalSoon2: false
    };
  }
  componentDidMount() { }
  render() {
    return (
      <div style={{ flexGrow: 1 }}>
        {this._modalSoon1()}
        {this._modalSoon2()}
        <header className="App-header1">
          <img src={logo} className="App-logo" alt="logo" />
        </header>
        <div style={{ padding: 25 }}>
          <Grid container style={{ justifyContent: "center" }} spacing={3}>
            <Grid item xs={6} md={4} style={{ justifyContent: "center", padding: 10 }}>
              <Card style={{ width: '100%', marginBottom: 5, justifyContent: 'center', alignItems: 'center' }}>
                <Link to="/novedades">
                  <CardActionArea style={{ padding: 0 }}>
                    <CardMedia
                      component="img"
                      alt="Novedades"
                      height="140"
                      image={nov}
                      title="Novedades"
                    />
                    <CardContent className="cardText" style={{ padding: 0, marginBottom: 15, marginTop: 10, width: '100%' }}>
                      <Typography
                        className="titWid"
                        gutterBottom
                        variant="h5"
                        component="h2"
                      >
                        Novedades
                      </Typography>
                      <Typography
                        className="subWid"
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Todos se enteran de todo en un instante.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Link>
              </Card>
            </Grid>
            <Grid item xs={6} md={4} style={{ justifyContent: "center" }}>
              <Card onClick={() => {this.openModalSoon1();}}
                style={{ width: '100%', marginBottom: 5, justifyContent: 'center', alignItems: 'center' }}>
                <Link to="/auditorias">
                  <CardActionArea style={{ padding: 0 }}>
                    <CardMedia
                      component="img"
                      alt="Auditorias"
                      height="140"
                      image={aud}
                      title="Auditorias"
                    />
                    <CardContent className="cardText" style={{ padding: 0, marginBottom: 15, marginTop: 10 }}>
                      <Typography
                        className="titWid"
                        gutterBottom
                        variant="h5"
                        component="h2"
                      >
                        Auditorias
                      </Typography>
                      <Typography
                        className="subWid"
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Todos se enteran de todo en un instante.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Link>
              </Card>
            </Grid>
          </Grid>
          <Grid container style={{ justifyContent: 'center' }} spacing={3}>
            <Grid item xs={6} md={4} style={{ justifyContent: 'center', padding: 10 }}>
              <Card style={{ width: '100%', marginBottom: 5, justifyContent: 'center', alignItems: 'center' }}
              >
                <Link to="/tickets">
                  <CardActionArea style={{ padding: 0 }}>
                    <CardMedia
                      component="img"
                      alt="Tickets"
                      height="140"
                      image={tick}
                      title="Tickets"
                    />
                    <CardContent className="cardText" style={{ padding: 0, marginBottom: 15, marginTop: 10, width: '100%' }}>
                      <Typography
                        className="titWid"
                        gutterBottom
                        variant="h5"
                        component="h2"
                      >
                        Tickets
                      </Typography>
                      <Typography
                        className="subWid"
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Todos se enteran de todo en un instante.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Link>
              </Card>
            </Grid>
            <Grid item xs={6} md={4} style={{ justifyContent: 'center', padding: 10 }}>
              <Card style={{ width: '100%', marginBottom: 5, justifyContent: 'center', alignItems: 'center' }}
              >
                <Link to="/archivos">
                  <CardActionArea style={{ padding: 0 }}>
                    <CardMedia
                      component="img"
                      alt="Archivos"
                      height="140"
                      image={arch}
                      title="Archivos"
                    />
                    <CardContent className="cardText" style={{ padding: 0, marginBottom: 15, marginTop: 10, width: '100%' }}>
                      <Typography
                        className="titWid"
                        gutterBottom
                        variant="h5"
                        component="h2"
                      >
                        Archivos
                      </Typography>
                      <Typography
                        className="subWid"
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        La nube, privada, disponible para todos.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Link>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>

      // <div className="App">
      //   {this._modalSoon()}
      //   <header className="App-header1">
      //     <img src={logo} className="App-logo" alt="logo" />
      //   </header>
      //   <div style={{ marginTop: 35 }}>
      //     <div className="homeCards">
      //       <div style={{ width: '35%', marginRight: 10 }}>
      //         <Card style={{ width: '100%', marginBottom: 5, justifyContent: 'center', alignItems: 'center' }}>
      //           <Link to="/novedades">
      //             <CardActionArea style={{ padding: 0 }}>
      //               <CardMedia
      //                 component="img"
      //                 alt="Novedades"
      //                 height="140"
      //                 image={nov}
      //                 title="Novedades"
      //               />
      //               <CardContent className="cardText" style={{ padding: 0, marginBottom: 15, marginTop: 10, width: '100%' }}>
      //                 <Typography
      //                   className="titWid"
      //                   gutterBottom
      //                   variant="h5"
      //                   component="h2"
      //                 >
      //                   Novedades
      //               </Typography>
      //                 <Typography
      //                   className="subWid"
      //                   variant="body2"
      //                   color="textSecondary"
      //                   component="p"
      //                 >
      //                   Todos se enteran de todo en un instante.
      //               </Typography>
      //               </CardContent>
      //             </CardActionArea>
      //           </Link>
      //         </Card>
      //       </div>
      //       <div style={{ width: '35%', marginLeft: 10 }}>
      //         <Card style={{ width: '100%', marginBottom: 5, justifyContent: 'center', alignItems: 'center' }}>
      //           <Link to="/editarFormulario">
      //             <CardActionArea style={{ padding: 0 }}>
      //               <CardMedia
      //                 component="img"
      //                 alt="Auditorias"
      //                 height="140"
      //                 image={aud}
      //                 title="Auditorias"
      //               />
      //               <CardContent className="cardText" style={{ padding: 0, marginBottom: 15, marginTop: 10 }}>
      //                 <Typography
      //                   className="titWid"
      //                   gutterBottom
      //                   variant="h5"
      //                   component="h2"
      //                 >
      //                   Auditorias
      //             </Typography>
      //                 <Typography
      //                   className="subWid"
      //                   variant="body2"
      //                   color="textSecondary"
      //                   component="p"
      //                 >
      //                   Todos se enteran de todo en un instante.
      //             </Typography>
      //               </CardContent>
      //             </CardActionArea>
      //           </Link>
      //         </Card>
      //       </div>
      //     </div>
      //     <div className="homeCards">
      //       <div style={{ width: '35%', marginRight: 10 }}>
      // <Card style={{ width: '100%', marginBottom: 5, justifyContent: 'center', alignItems: 'center' }}
      //   className="card"
      //   onClick={() => {
      //     this.openModalSoon();
      //   }}
      // >
      //   <CardActionArea style={{ padding: 0 }}>
      //     <CardMedia
      //       component="img"
      //       alt="Tickets"
      //       height="140"
      //       image={tick}
      //       title="Tickets"
      //     />
      //     <CardContent className="cardText" style={{ padding: 0, marginBottom: 15, marginTop: 10, width: '100%' }}>
      //       <Typography
      //         className="titWid"
      //         gutterBottom
      //         variant="h5"
      //         component="h2"
      //       >
      //         Tickets
      //     </Typography>
      //       <Typography
      //         className="subWid"
      //         variant="body2"
      //         color="textSecondary"
      //         component="p"
      //       >
      //         Todos se enteran de todo en un instante.
      //     </Typography>
      //     </CardContent>
      //   </CardActionArea>
      // </Card>
      //       </div>
      //       <div style={{ width: '35%', marginLeft: 10 }}>
      // <Card style={{ width: '100%', marginBottom: 5, justifyContent: 'center', alignItems: 'center' }}
      //   className="card"
      //   onClick={() => {
      //     this.openModalSoon();
      //   }}
      // >
      //   <CardActionArea style={{ padding: 0 }}>
      //     <CardMedia
      //       component="img"
      //       alt="Archivos"
      //       height="140"
      //       image={arch}
      //       title="Archivos"
      //     />
      //     <CardContent className="cardText" style={{ padding: 0, marginBottom: 15, marginTop: 10, width: '100%' }}>
      //       <Typography
      //         className="titWid"
      //         gutterBottom
      //         variant="h5"
      //         component="h2"
      //       >
      //         Archivos
      //     </Typography>
      //       <Typography
      //         className="subWid"
      //         variant="body2"
      //         color="textSecondary"
      //         component="p"
      //       >
      //         La nube, privada, disponible para todos.
      //     </Typography>
      //     </CardContent>
      //   </CardActionArea>
      // </Card>
      //       </div>
      //     </div>
      //   </div>
      // </div>
    );
  }
  closeModalSoon1 = () => {
    this.setState({ modalSoon1: false });
  };
  openModalSoon1 = () => {
    this.setState({ modalSoon1: true });
  };
  closeModalSoon2 = () => {
    this.setState({ modalSoon2: false });
  };
  openModalSoon2 = () => {
    this.setState({ modalSoon2: true });
  };
  _modalSoon1 = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modalSoon}
        open={this.state.modalSoon1}
        onClose={() => {
          this.closeModalSoon1();
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Card
          style={{
            margin: "auto",
            marginTop: 100,
            width: window.innerWidth < 600 ? '70%' : '50%',
            height: '60%',
            alignItems: "center"
          }}
        >
          <CardContent className="textCardNov2" />
          <CardMedia
            style={{
              height: "50%",
              width: "50%",
              margin: "auto",
              backgroundSize: "contain"
            }}
            className="textCardNov2"
            image={nov}
            title="soon"
          />
          <CardContent
            className="textCardNov2"
            style={{
              textAlign: "center !important",
              alignContent: "center !important"
            }}
          >
            <Typography
              className="titCard"
              style={{ textAlign: "center" }}
              gutterBottom
              variant="h5"
              component="h2"
            >
              Primero probá Novedades
            </Typography>
            <Typography
              variant="txtCardNov"
              color="textSecondary"
              component="p"
            >
              {/*         Esta funcionalidad estará disponible muy pronto!!*/}
            </Typography>
            <Button
              className="btn2"
              onClick={() => {
                this.closeModalSoon1();
              }}
            >
              <Typography className="btnNewNov2">ACEPTAR</Typography>
            </Button>
          </CardContent>
        </Card>
      </Modal>
    );
  };
  _modalSoon2 = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modalSoon}
        open={this.state.modalSoon2}
        onClose={() => {
          this.closeModalSoon2();
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Card
          style={{
            margin: "auto",
            marginTop: 100,
            width: window.innerWidth < 600 ? '70%' : '50%',
            height: '60%',
            alignItems: "center"
          }}
        >
          <CardContent className="textCardNov2" />
          <CardMedia
            style={{
              height: "50%",
              width: "50%",
              margin: "auto",
              backgroundSize: "contain"
            }}
            className="textCardNov2"
            image={arch}
            title="soon"
          />
          <CardContent
            className="textCardNov2"
            style={{
              textAlign: "center !important",
              alignContent: "center !important"
            }}
          >
            <Typography
              className="titCard"
              style={{ textAlign: "center" }}
              gutterBottom
              variant="h5"
              component="h2"
            >
              Primero probá Archivos
            </Typography>
            <Typography
              variant="txtCardNov"
              color="textSecondary"
              component="p"
            >
              {/*         Esta funcionalidad estará disponible muy pronto!!*/}
            </Typography>
            <Button
              className="btn2"
              onClick={() => {
                this.closeModalSoon2();
              }}
            >
              <Typography className="btnNewNov2">ACEPTAR</Typography>
            </Button>
          </CardContent>
        </Card>
      </Modal>
    );
  };
}
const useStyles = makeStyles(theme => ({
  modalSoon: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // flexDirection: 'row',
    // flex: 1,
    justifyContent: "center",
    overflow: "scroll"
  }
}));
